import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Switch,
  TextField,
  MenuItem,
  RadioGroup,
  Radio,
  FormControlLabel,
  Paper,
  FormControl,
  FormHelperText,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid,
} from "@mui/material";
import graphqlRequest from "../../../requestMethod";
import CloseIcon from "@mui/icons-material/Close";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import { useDispatch, useSelector } from "react-redux";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

export default function PaymentModal({
  open,
  onClose,
  rowClickedData,
  handleCreateOrder,
}) {
  // console.log("paymentMode", rowClickedData?.paymentMode);
  let dataForType;
  if (rowClickedData?.branch?.paymentType === "FULL_PAYMENT") {
    // console.log("here 1");
    dataForType = "FULL_PAYMENT";
  } else if (
    rowClickedData?.branch?.paymentType === "PARTIAL_PAYMENT" &&
    rowClickedData?.paymentMode === "partial_payment"
  ) {
    // console.log("here 2");
    dataForType = "FULL_PAYMENT";
  } else {
    // console.log("here 3");
    dataForType = "PARTIAL_PAYMENT";
  }

  // const [paymentType, setPaymentType] = useState("full");
  const [paymentType, setPaymentType] = useState(
    dataForType === "FULL_PAYMENT" ? "full" : "partial"
  );

  // console.log("paymentType", paymentType);
  const [partialValue, setPartialValue] = useState(25);
  const [tdsEnabled, setTdsEnabled] = useState(false);
  const [billTds, setBillTds] = useState(0);
  const [invoiceTds, setInvoiceTds] = useState(2);
  const [tanNumber, setTanNumber] = useState("");
  const [tanFile, setTanFile] = useState(null);
  const [payable, setPayable] = useState(0);
  const [uploadFileUrl, setUploadFileUrl] = useState("");
  const [editingTan, setEditingTan] = useState(false);
  const [editingFile, setEditingFile] = useState(false);

  const fileUploadRef = useRef(null);

  let dispatch = useDispatch();
  const handlePaymentType = (_, newValue) => {
    if (newValue !== null) setPaymentType(newValue);
  };
  // console.log("in paymentModal", rowClickedData);
  const tanNumberData =
    rowClickedData?.branch?.billingInfo?.gstDetails?.tanNumber;
  const tanNumberFileUrlData =
    rowClickedData?.branch?.billingInfo?.gstDetails?.tanCertificate?.fileUrl;

  const previousDueAmount =
    parseFloat(rowClickedData?.cashfreeAmountReceived || 0) +
    (parseFloat(rowClickedData?.tdsBillOfSupplyDeduction || 0) +
      parseFloat(rowClickedData?.tdsTaxInvoiceDeduction || 0));

  // console.log("previousDueAmount", previousDueAmount);
  const amountDue = rowClickedData?.amount - previousDueAmount;
  // console.log("amountDue", amountDue);

  const billOfSupplyTDSPercentage =
    (rowClickedData?.tdsBillOfSupplyDeduction / rowClickedData?.cost) * 100;
  const invoiceTDSPercentage =
    (rowClickedData?.tdsTaxInvoiceDeduction / rowClickedData?.convensionFee) *
    100;

  // console.log("billOfSupplyTDSPercentage", billOfSupplyTDSPercentage);

  const previousPaymentMode = rowClickedData?.paymentMode;
  const billOfSupplyTds = (billTds / 100) * rowClickedData?.cost;
  const invoiceTaxTds =
    tdsEnabled === true
      ? (invoiceTds / 100) * rowClickedData?.convensionFee
      : (0 / 100) * rowClickedData?.convensionFee;
  // const totalTdsDeduction =
  //   billOfSupplyTDSPercentage && invoiceTDSPercentage
  //     ? 0
  //     : billOfSupplyTds + invoiceTaxTds;
  let totalTdsDeduction = 0;

  if (billOfSupplyTDSPercentage) {
    // agar present hai to uske liye 0 hi lena
    totalTdsDeduction += 0;
  } else {
    // agar nahi hai to uska tds uthao
    totalTdsDeduction += billOfSupplyTds || 0;
  }

  if (invoiceTDSPercentage) {
    // agar present hai to uske liye 0 hi lena
    totalTdsDeduction += 0;
  } else {
    // agar nahi hai to uska tds uthao
    totalTdsDeduction += invoiceTaxTds || 0;
  }

  //  console.log("totalTdsDeduction", totalTdsDeduction);

  // const tdsDeduction = ((billTds + invoiceTds) / 100) * amountDue;
  // const amountPayable = amountDue - tdsDeduction;
  // console.log("billOfSupplyTds", billOfSupplyTds);
  // console.log("invoiceTaxTds", invoiceTaxTds);
  // console.log("totalTdsDeduction", totalTdsDeduction);
  const partialPayablePercentageAmount = amountDue - totalTdsDeduction;
  let amountPayable;
  if (paymentType === "full") {
    amountPayable = amountDue - totalTdsDeduction;
  } else {
    amountPayable = payable;
  }
  // const payable = (creditLimit * partialValue) / 100;
  // const payable = (amountDue * partialValue) / 100;
  // console.log("partialValue", partialValue);
  // console.log("payable", payable);
  // console.log("partialPayablePercentageAmount", partialPayablePercentageAmount);
  useEffect(() => {
    if (partialValue) {
      setPayable((partialPayablePercentageAmount * partialValue) / 100);
    } else {
      setPayable(25);
    }
  }, [partialValue, partialPayablePercentageAmount]);

  const getSignedUrl = async () => {
    const query = `
      query {
        getSignedUrl(filename: "${tanFile?.name}") {
          location
          fileName
          uri
            bucket
            region
            mimeType
            secureUrl
            url
            isSecured
            cdnUrl
          }
        }
      `;

    const json = await graphqlRequest(query);
    // console.log("Signed URL response:", json);
    const res = await fetch(json.data.getSignedUrl.secureUrl, {
      method: "PUT",
      body: tanFile,
      headers: {
        "Content-Type": tanFile.type,
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    });
    // console.log("res===", res);
    if (res.ok) {
      const baseUrl = res.url.split("?")[0];
      // console.log("baseUrl", baseUrl);
      setUploadFileUrl(baseUrl);
    }
  };

  const updateBranch = async () => {
    try {
      const data = localStorage.getItem("auth");
      const token = JSON.parse(data)?.accessToken;

      const query = `
       mutation{
  mutationWithAuth(token: "${token}") {
    update{
      updateBranchOnPayment(branchId: "${rowClickedData?.branch?.id}",  data: {tanNumber: "${tanNumber}", tanCertificate: "${uploadFileUrl}"})
    }
  }
}
      `;

      const response = await graphqlRequest(query);
      // console.log("updatedBranch", response);
      // if (response?.data?.mutationWithAuth?.update?.updateBranchOnPayment) {
      //   toast.success("Branch updated successfully");
      // }
    } catch (err) {
      console.error("Error creating order:", err);
    }
  };

  useEffect(() => {
    if (tanFile?.name) getSignedUrl();
  }, [tanFile?.name]);

  useEffect(() => {
    if (editingTan || tanNumber || editingFile || uploadFileUrl) {
      updateBranch();
    }
  }, [tanNumber, uploadFileUrl]);

  // useEffect(() => {
  //   if (tanNumber && uploadFileUrl) updateBranch();
  // }, [tanNumber,uploadFileUrl]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        editingFile &&
        fileUploadRef.current &&
        !fileUploadRef.current.contains(event.target)
      ) {
        if (!tanFile) {
          setEditingFile(false); // reset to existing file view
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [editingFile, tanFile]);

  useEffect(() => {
    if (
      rowClickedData?.branch?.paymentType === "PARTIAL_PAYMENT" &&
      rowClickedData?.paymentMode === "partial_payment"
    ) {
      setPaymentType("full");
    } else if (rowClickedData?.branch?.paymentType === "FULL_PAYMENT") {
      setPaymentType("full");
    } else {
      setPaymentType("partial");
    }
    // if(rowClickedData?.branch?.paymentType){

    // }
  }, [rowClickedData?.branch?.paymentType]);

  // let finalPayableAmount = paymentType === "partial" ? payable : amountPayable;
  // console.log("tanFile", tanFile);
  // console.log("tanNumberFileUrlData", tanNumberFileUrlData);
  return (
    // <Modal open={open} onClose={onClose}>
    <Modal
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          onClose();
        }
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 600,
          maxHeight: "90vh",
          overflowY: "auto",
          bgcolor: "white",
          borderRadius: "12px",
          boxShadow: 24,
          // p: 4,
          pt: 0, // 👈 top padding 0
          pr: 4, // right padding 32px
          pb: 4, // bottom padding 32px
          pl: 4,
        }}
      >
        {/* header */}
        <Box
          sx={{
            position: "sticky",
            top: 0,
            bgcolor: "white",
            zIndex: 10,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          {/* Left side - Title */}
          <Typography variant="h6" fontWeight={600}>
            Process Payment
          </Typography>

          {/* Right side - Cross button */}
          <IconButton
            onClick={onClose}
            sx={{
              mt: -3,
              mr: -5,
            }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography variant="body2" color="text.secondary" mt={1}>
          Choose payment type and review the cost breakdown before proceeding.
        </Typography>
        {/* Amount Due */}
        {paymentType === "full" && (
          <Box
            mt={3}
            p={2}
            sx={{
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          >
            <Grid container alignItems="center" justifyContent="center">
              {/* BOS */}
              <Grid item xs={3} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>BOS</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹{parseFloat(rowClickedData?.cost)?.toLocaleString("en-IN")}
                </Typography>
              </Grid>

              {/* Plus sign */}
              <Grid item xs={1} sx={{ textAlign: "center" }}>
                <Typography fontWeight={700} fontSize="1.5rem">
                  +
                </Typography>
              </Grid>

              {/* Tax Invoice */}
              <Grid item xs={3} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>Tax Invoice</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹
                  {(
                    rowClickedData?.amount - rowClickedData?.cost
                  )?.toLocaleString("en-IN")}
                </Typography>
              </Grid>

              {/* Equal sign */}
              <Grid item xs={1} sx={{ textAlign: "center" }}>
                <Typography fontWeight={700} fontSize="1.5rem">
                  =
                </Typography>
              </Grid>

              {/* Amount Due */}
              <Grid item xs={4} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>Amount Due</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹{parseFloat(rowClickedData?.amount)?.toLocaleString("en-IN")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          // <Box
          //   mt={3}
          //   p={2}
          //   sx={{
          //     border: "1px solid #ddd",
          //     borderRadius: "8px",
          //     display: "flex",
          //     justifyContent: "space-between",
          //   }}
          // >
          //   <Typography fontWeight={500}>Amount Due</Typography>
          //   <Typography fontWeight={600} fontSize="1.1rem">
          //     ₹{amountDue?.toLocaleString("en-IN")}
          //   </Typography>
          // </Box>
        )}
        {paymentType === "partial" && (
          <Box
            mt={3}
            p={2}
            sx={{
              border: "1px solid #ddd",
              borderRadius: "8px",
            }}
          >
            <Grid container alignItems="center" justifyContent="center">
              {/* BOS */}
              <Grid item xs={3} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>BOS</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹{parseFloat(rowClickedData?.cost)?.toLocaleString("en-IN")}
                </Typography>
              </Grid>

              {/* Plus sign */}
              <Grid item xs={1} sx={{ textAlign: "center" }}>
                <Typography fontWeight={700} fontSize="1.5rem">
                  +
                </Typography>
              </Grid>

              {/* Tax Invoice */}
              <Grid item xs={3} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>Tax Invoice</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹
                  {(
                    rowClickedData?.amount - rowClickedData?.cost
                  )?.toLocaleString("en-IN")}
                </Typography>
              </Grid>

              {/* Equal sign */}
              <Grid item xs={1} sx={{ textAlign: "center" }}>
                <Typography fontWeight={700} fontSize="1.5rem">
                  =
                </Typography>
              </Grid>

              {/* Amount Due */}
              <Grid item xs={4} sx={{ textAlign: "center" }}>
                <Typography fontWeight={500}>Amount Due</Typography>
                <Typography fontWeight={600} fontSize="1.1rem">
                  ₹{parseFloat(rowClickedData?.amount)?.toLocaleString("en-IN")}
                </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
        {/* Payment Type */}
        {/* Payment Type */}
        <Typography mt={3} mb={1} fontWeight={500}>
          Payment Type
        </Typography>

        <ToggleButtonGroup
          value={paymentType}
          exclusive
          onChange={handlePaymentType}
          sx={{
            mb: 2,
            display: "flex",
            gap: 2,
          }}
          fullWidth
        >
          {/* Full Payment Toggle */}
          {(rowClickedData?.paymentMode === "partial_payment" || // agar partial_paid hai to sirf full
            rowClickedData?.branch?.paymentType === "FULL_PAYMENT" ||
            rowClickedData?.branch?.paymentType === "PARTIAL_PAYMENT") && (
            <ToggleButton
              value="full"
              sx={{
                flex: 1,
                borderRadius: "8px !important",
                border: "1px solid #ccc",
                textTransform: "none",
                justifyContent: "flex-start",
                gap: 1,
              }}
            >
              {paymentType === "full" ? (
                <RadioButtonCheckedIcon fontSize="small" />
              ) : (
                <RadioButtonUncheckedIcon fontSize="small" />
              )}
              Full Payment
            </ToggleButton>
          )}

          {/* Partial Payment Toggle - Only visible if PARTIAL_PAYMENT and NOT partial_paid */}
          {rowClickedData?.branch?.paymentType === "PARTIAL_PAYMENT" &&
            rowClickedData?.paymentMode !== "partial_payment" && (
              <ToggleButton
                value="partial"
                sx={{
                  flex: 1,
                  borderRadius: "8px !important",
                  border: "1px solid #ccc",
                  textTransform: "none",
                  justifyContent: "flex-start",
                  gap: 1,
                  borderLeft: "1px solid #ccc !important",
                }}
              >
                {paymentType === "partial" ? (
                  <RadioButtonCheckedIcon fontSize="small" />
                ) : (
                  <RadioButtonUncheckedIcon fontSize="small" />
                )}
                Partial Payment
              </ToggleButton>
            )}
        </ToggleButtonGroup>

        {/* TDS Switch - Only show when Full Payment */}
        {paymentType === "full" && (
          <>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={2}
            >
              <Typography fontWeight={500}>Deduct TDS?</Typography>
              <Switch
                checked={tdsEnabled}
                onChange={() => setTdsEnabled(!tdsEnabled)}
              />
            </Box>

            {/* TDS Fields - Only show when toggle enabled */}
            {tdsEnabled && (
              <Box mt={2} display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                <TextField
                  select
                  label="Bill of Supply: TDS %"
                  value={
                    billOfSupplyTDSPercentage !== undefined &&
                    !isNaN(billOfSupplyTDSPercentage) &&
                    billOfSupplyTDSPercentage > 0
                      ? billOfSupplyTDSPercentage
                      : billTds
                  }
                  onChange={(e) => setBillTds(Number(e.target.value))}
                  disabled={
                    billOfSupplyTDSPercentage !== undefined &&
                    !isNaN(billOfSupplyTDSPercentage) &&
                    billOfSupplyTDSPercentage > 0
                  }
                >
                  {(billOfSupplyTDSPercentage !== undefined &&
                  !isNaN(billOfSupplyTDSPercentage) &&
                  billOfSupplyTDSPercentage > 0
                    ? [billOfSupplyTDSPercentage]
                    : [0, 2, 10]
                  ).map((v) => (
                    <MenuItem key={v} value={v}>
                      {v}%
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  select
                  label="Tax Invoice: TDS %"
                  // value={invoiceTds}

                  value={
                    invoiceTDSPercentage !== undefined &&
                    !isNaN(invoiceTDSPercentage) &&
                    invoiceTDSPercentage > 0
                      ? invoiceTDSPercentage
                      : invoiceTds
                  }
                  onChange={(e) => setInvoiceTds(Number(e.target.value))}
                  disabled={
                    invoiceTDSPercentage !== undefined &&
                    !isNaN(invoiceTDSPercentage) &&
                    invoiceTDSPercentage > 0
                  }
                >
                  {/* {[0, 2, 10].map((v) => (
                    <MenuItem key={v} value={v}>
                      {v}%
                    </MenuItem>
                  ))} */}
                  {(invoiceTDSPercentage !== undefined &&
                  !isNaN(invoiceTDSPercentage) &&
                  invoiceTDSPercentage > 0
                    ? [invoiceTDSPercentage]
                    : [0, 2, 10]
                  ).map((v) => (
                    <MenuItem key={v} value={v}>
                      {v}%
                    </MenuItem>
                  ))}
                </TextField>

                {/* TAN Number - Mandatory when TDS enabled */}
                <TextField
                  label="TAN Number"
                  placeholder="AAAA00000A"
                  value={
                    editingTan ? tanNumber : tanNumberData || tanNumber || ""
                  }
                  // onChange={(e) => {
                  //   const val = e.target.value;
                  //   if (/^[0-9]*$/.test(val)) {
                  //     setTanNumber(val);
                  //   }
                  // }}
                  onChange={(e) => {
                    const val = e.target.value.toUpperCase(); // auto-uppercase
                    if (/^[A-Z0-9]*$/.test(val) && val.length <= 10) {
                      setTanNumber(val);
                    }
                  }}
                  onBlur={() => {
                    if (!tanNumber) {
                      setEditingTan(false);
                      setTanNumber(tanNumberData || "");
                    }
                  }}
                  required={tdsEnabled}
                  // error={tdsEnabled && !tanNumber && !tanNumberData}
                  error={
                    tdsEnabled &&
                    !(
                      (tanNumber &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)) ||
                      (tanNumberData &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumberData))
                    )
                  }
                  // helperText={
                  //   tdsEnabled && !tanNumber && !tanNumberData
                  //     ? "TAN Number is required"
                  //     : ""
                  // }
                  helperText={
                    tdsEnabled &&
                    !(
                      (tanNumber &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)) ||
                      (tanNumberData &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumberData))
                    )
                      ? "Enter a valid TAN Number (e.g., RTKI05026A)"
                      : ""
                  }
                  fullWidth
                  disabled={!!tanNumberData && !editingTan}
                  sx={{
                    width: "260px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& fieldset": {
                        // border: "1px solid #ccc",
                        border: "none",
                      },
                      "&.Mui-error fieldset": {
                        border: "1px solid red",
                      },
                      height: "49px",
                      "&.Mui-disabled .MuiOutlinedInput-input": {
                        color: "#1976d2",
                        WebkitTextFillColor: "#1976d2",
                        borderColor: "#1976d2",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color:
                        tanNumberData && !editingTan
                          ? "#1976d2"
                          : "rgba(0, 0, 0, 0.6)",
                      backgroundColor: "#fff",
                      padding: "0 4px",
                      zIndex: 1,
                      "&.Mui-disabled": {
                        color: "#1976d2",
                      },
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },

                    "& .MuiOutlinedInput-input": {
                      height: "49px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                      color: "black",
                      "&::placeholder": {
                        color: "rgba(0, 0, 0, 0.6)",
                        opacity: 1,
                      },
                    },
                  }}
                  InputProps={{
                    // endAdornment: tanNumberData && !editingTan && (
                    //   <EditIcon
                    //     sx={{ cursor: "pointer", ml: 1, color: "#616161" }}
                    //     onClick={() => setEditingTan(true)}
                    //   />
                    // ),
                    style: {
                      display: "flex",
                      alignItems: "center",
                      height: "49px",
                    },
                  }}
                />

                {/* TAN Certificate Upload - Mandatory when TDS enabled */}
                <FormControl
                  fullWidth
                  error={tdsEnabled && !tanFile && !tanNumberFileUrlData}
                >
                  {!editingFile && tanNumberFileUrlData ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}

                      // mt={0.5}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() =>
                          window.open(tanNumberFileUrlData, "_blank")
                        }
                        sx={{
                          height: "49px", // ✅ same height
                          minWidth: editingFile ? "240px" : "259px",
                        }}
                      >
                        View TAN Certificate
                      </Button>
                      {/* <EditIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => setEditingFile(true)}
                      /> */}
                    </Box>
                  ) : (
                    <Box ref={fileUploadRef}>
                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          height: "49px",
                          minWidth: editingFile ? "240px" : "259px",
                          textTransform: "none",

                          justifyContent: "center",
                          borderStyle:
                            tdsEnabled && !tanFile ? "dashed" : "solid",
                        }}
                        color={tdsEnabled && !tanFile ? "error" : "primary"}
                        endIcon={
                          (tanFile || tanNumberFileUrlData) && (
                            <VisibilityIcon
                              sx={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                const fileUrl = tanFile
                                  ? URL.createObjectURL(tanFile)
                                  : tanNumberFileUrlData;
                                window.open(fileUrl, "_blank");
                              }}
                            />
                          )
                        }
                      >
                        {tanFile ? tanFile.name : "Upload TAN Certificate *"}
                        <input
                          type="file"
                          hidden
                          onChange={(e) => setTanFile(e.target.files[0])}
                          required={tdsEnabled}
                        />
                      </Button>
                    </Box>
                  )}

                  {/* Error message */}
                  {tdsEnabled && !tanFile && !tanNumberFileUrlData && (
                    <FormHelperText>TAN Certificate is required</FormHelperText>
                  )}
                </FormControl>
              </Box>
            )}

            {tdsEnabled && (
              <>
                <Typography variant="caption" color="text.secondary" mt={1}>
                  Note: Submit TAN Number and TAN Certificate to process payment
                </Typography>

                {billOfSupplyTDSPercentage !== undefined &&
                  !isNaN(billOfSupplyTDSPercentage) &&
                  billOfSupplyTDSPercentage > 0 &&
                  invoiceTDSPercentage !== undefined &&
                  !isNaN(invoiceTDSPercentage) &&
                  invoiceTDSPercentage > 0 && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      gutterBottom
                      mt={2}
                    >
                      TDS Deducted: ₹
                      {(
                        parseFloat(
                          rowClickedData?.tdsBillOfSupplyDeduction || 0
                        ) +
                        parseFloat(rowClickedData?.tdsTaxInvoiceDeduction || 0)
                      ).toLocaleString("en-IN")}
                    </Typography>
                  )}
              </>
            )}

            {/* Summary */}
            <Box
              mt={3}
              p={2}
              sx={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                bgcolor: "#fafafa",
              }}
            >
              <Box display="flex" justifyContent="space-between" mb={1}>
                <Typography>Bill Amount</Typography>
                <Typography>
                  ₹
                  {amountDue?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
              {!(billOfSupplyTDSPercentage && invoiceTDSPercentage) && (
                <Box display="flex" justifyContent="space-between" mb={1}>
                  <Typography>TDS Deduction</Typography>
                  <Typography>
                    - ₹
                    {totalTdsDeduction?.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}
                  </Typography>
                </Box>
              )}
              <Box
                display="flex"
                justifyContent="space-between"
                fontWeight={600}
                mt={1}
              >
                <Typography>Amount Payable</Typography>
                <Typography>
                  ₹
                  {amountPayable?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
            </Box>
          </>
        )}
        {paymentType === "partial" && (
          <Box>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mt={2}
            >
              <Typography fontWeight={500}>Deduct TDS?</Typography>
              <Switch
                checked={tdsEnabled}
                onChange={() => setTdsEnabled(!tdsEnabled)}
              />
            </Box>
            {/* TDS Fields - Only show when toggle enabled */}
            {tdsEnabled && (
              <Box mt={2} display="grid" gridTemplateColumns="1fr 1fr" gap={2}>
                {/* Bill of Supply */}
                <Box>
                  <TextField
                    select
                    fullWidth
                    label="Bill of Supply: TDS %"
                    value={billTds}
                    onChange={(e) => setBillTds(Number(e.target.value))}
                  >
                    {[0, 2, 10].map((v) => (
                      <MenuItem key={v} value={v}>
                        {v}%
                      </MenuItem>
                    ))}
                  </TextField>
                  <Typography variant="body2" color="text.secondary" mt={1}>
                    Deduction Amount: ₹{billOfSupplyTds?.toLocaleString()}
                  </Typography>
                </Box>

                {/* Tax Invoice */}
                <Box>
                  <TextField
                    select
                    fullWidth
                    label="Tax Invoice: TDS %"
                    value={invoiceTds}
                    onChange={(e) => setInvoiceTds(Number(e.target.value))}
                  >
                    {[0, 2, 10].map((v) => (
                      <MenuItem key={v} value={v}>
                        {v}%
                      </MenuItem>
                    ))}
                  </TextField>
                  <Typography variant="body2" color="text.secondary" mt={1}>
                    Deduction Amount: ₹{invoiceTaxTds?.toLocaleString()}
                  </Typography>
                </Box>

                {/* TAN Number - Mandatory when TDS enabled */}
                <TextField
                  label="TAN Number"
                  placeholder="AAAA00000A"
                  value={
                    editingTan ? tanNumber : tanNumberData || tanNumber || ""
                  }
                  // onChange={(e) => {
                  //   const val = e.target.value;
                  //   if (/^[0-9]*$/.test(val)) {
                  //     setTanNumber(val);
                  //   }
                  // }}
                  onChange={(e) => {
                    const val = e.target.value.toUpperCase(); // auto-uppercase
                    if (/^[A-Z0-9]*$/.test(val) && val.length <= 10) {
                      setTanNumber(val);
                    }
                  }}
                  onBlur={() => {
                    if (!tanNumber) {
                      setEditingTan(false);
                      setTanNumber(tanNumberData || "");
                    }
                  }}
                  required={tdsEnabled}
                  // error={tdsEnabled && !tanNumber && !tanNumberData}
                  error={
                    tdsEnabled &&
                    !(
                      (tanNumber &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)) ||
                      (tanNumberData &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumberData))
                    )
                  }
                  // helperText={
                  //   tdsEnabled && !tanNumber && !tanNumberData
                  //     ? "TAN Number is required"
                  //     : ""
                  // }
                  helperText={
                    tdsEnabled &&
                    !(
                      (tanNumber &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)) ||
                      (tanNumberData &&
                        /^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumberData))
                    )
                      ? "Enter a valid TAN Number (e.g., RTKI05026A)"
                      : ""
                  }
                  fullWidth
                  disabled={!!tanNumberData && !editingTan} // ✅ sirf existing value hone par disable
                  sx={{
                    width: "260px",
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "8px",
                      "& fieldset": {
                        // border: "1px solid #ccc",
                        border: "none",
                      },
                      "&.Mui-error fieldset": {
                        border: "1px solid red",
                      },
                      height: "49px",
                      "&.Mui-disabled .MuiOutlinedInput-input": {
                        color: "#1976d2",
                        WebkitTextFillColor: "#1976d2",
                        borderColor: "#1976d2",
                      },
                    },
                    "& .MuiInputLabel-root": {
                      color:
                        tanNumberData && !editingTan
                          ? "#1976d2"
                          : "rgba(0, 0, 0, 0.6)",
                      backgroundColor: "#fff",
                      padding: "0 4px",
                      zIndex: 1,
                      "&.Mui-disabled": {
                        color: "#1976d2",
                      },
                      "&.Mui-focused": {
                        color: "#1976d2",
                      },
                    },

                    "& .MuiOutlinedInput-input": {
                      height: "49px",
                      padding: "0 14px",
                      boxSizing: "border-box",
                      color: "black",
                      "&::placeholder": {
                        color: "rgba(0, 0, 0, 0.6)",
                        opacity: 1,
                      },
                    },
                  }}
                  InputProps={{
                    // endAdornment: tanNumberData && !editingTan && (
                    //   <EditIcon
                    //     sx={{ cursor: "pointer", ml: 1, color: "#616161" }}
                    //     onClick={() => setEditingTan(true)}
                    //   />
                    // ),
                    style: {
                      display: "flex",
                      alignItems: "center",
                      height: "49px",
                    },
                  }}
                />

                {/* TAN Certificate Upload - Mandatory when TDS enabled */}
                <FormControl
                  fullWidth
                  error={tdsEnabled && !tanFile && !tanNumberFileUrlData}
                >
                  {!editingFile && tanNumberFileUrlData ? (
                    <Box
                      display="flex"
                      alignItems="center"
                      gap={1}

                      // mt={0.5}
                    >
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={() =>
                          window.open(tanNumberFileUrlData, "_blank")
                        }
                        sx={{
                          height: "49px", // ✅ same height
                          minWidth: editingFile ? "240px" : "259px",
                        }}
                      >
                        View TAN Certificate
                      </Button>
                      {/* <EditIcon
                        sx={{ cursor: "pointer" }}
                        onClick={() => setEditingFile(true)}
                      /> */}
                    </Box>
                  ) : (
                    <Box ref={fileUploadRef}>
                      <Button
                        variant="outlined"
                        component="label"
                        sx={{
                          height: "49px", // ✅ same height
                          minWidth: editingFile ? "240px" : "259px",
                          textTransform: "none",

                          justifyContent: "center",
                          borderStyle:
                            tdsEnabled && !tanFile ? "dashed" : "solid",
                        }}
                        color={tdsEnabled && !tanFile ? "error" : "primary"}
                        endIcon={
                          (tanFile || tanNumberFileUrlData) && (
                            <VisibilityIcon
                              sx={{ cursor: "pointer" }}
                              onClick={(e) => {
                                e.stopPropagation(); // button ka file select event block kar de
                                const fileUrl = tanFile
                                  ? URL.createObjectURL(tanFile)
                                  : tanNumberFileUrlData;
                                window.open(fileUrl, "_blank");
                              }}
                            />
                          )
                        }
                      >
                        {tanFile ? tanFile.name : "Upload TAN Certificate *"}
                        <input
                          type="file"
                          hidden
                          onChange={(e) => setTanFile(e.target.files[0])}
                          required={tdsEnabled}
                        />
                      </Button>
                    </Box>
                  )}

                  {/* Error message */}
                  {tdsEnabled && !tanFile && !tanNumberFileUrlData && (
                    <FormHelperText>TAN Certificate is required</FormHelperText>
                  )}
                </FormControl>
              </Box>
            )}

            {tdsEnabled && (
              <Typography variant="caption" color="text.secondary" mt={1}>
                Note: Submit TAN Number and TAN Certificate to process payment
              </Typography>
            )}

            <Typography fontWeight="500" gutterBottom mt={2}>
              Select Partial Payment Amount
            </Typography>
            {/* <Typography variant="body2" color="text.secondary" mt={2}>
              🚧 Coming Soon...
            </Typography> */}

            <Typography
              variant="body2"
              color="text.secondary"
              gutterBottom
              mt={2}
            >
              Amount Payable: ₹
              {partialPayablePercentageAmount?.toLocaleString()}
            </Typography>

            {parseFloat(rowClickedData?.cashfreeAmountReceived) > 0 && (
              <Typography
                variant="body2"
                color="text.secondary"
                gutterBottom
                mt={2}
              >
                Last Amount Receive: ₹
                {rowClickedData?.cashfreeAmountReceived?.toLocaleString()}
              </Typography>
            )}

            {/* Partial Payment Options */}
            <RadioGroup
              value={partialValue}
              onChange={(e) => {
                setPartialValue(Number(e.target.value));
              }}
            >
              {[25, 50, 75].map((val) => (
                <Paper
                  key={val}
                  variant="outlined"
                  sx={{
                    mb: 1,
                    p: 1,
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <FormControlLabel
                    value={val}
                    control={<Radio />}
                    label={`${val}% of Amount Payable (₹${(
                      (partialPayablePercentageAmount * val) /
                      100
                    )?.toLocaleString()})`}
                    sx={{ flex: 1, m: 0 }}
                  />
                </Paper>
              ))}
            </RadioGroup>

            {/* Summary */}
            <Box
              mt={3}
              p={2}
              sx={{
                border: "1px solid #ddd",
                borderRadius: "8px",
                bgcolor: "#fafafa",
              }}
            >
              <Box
                display="flex"
                justifyContent="space-between"
                fontWeight={600}
                mt={1}
              >
                <Typography>Partial Amount Payable</Typography>
                <Typography>
                  ₹
                  {amountPayable?.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}
                </Typography>
              </Box>
            </Box>
          </Box>
        )}
        {/* Footer */}

        <Box display="flex" justifyContent="flex-end" mt={4} gap={2}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            sx={{ textTransform: "none" }}
            onClick={() => {
              handleCreateOrder(
                paymentType,
                billOfSupplyTds,
                invoiceTaxTds,
                amountPayable
              );
              onClose();
            }}
            disabled={
              tdsEnabled &&
              (!(tanNumber || tanNumberData) ||
                !(tanFile?.name || tanNumberFileUrlData) ||
                (tanNumber && !/^[A-Z]{4}[0-9]{5}[A-Z]$/.test(tanNumber)))
            }
          >
            Process Payment
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
